import React from 'react';
import { IconCaretDownNoRadius } from '../../../assets/icons';
import $ from 'jquery';
import { NavbarLink } from '../../../types/navbar.type';
import { TranslationUtils } from '../../../utils';
import { companyLinks } from '../links';

const onKeyPress = () => {
    $('#company-dropdown-link').click();
};

const renderLink = (link: NavbarLink) => {
    return (
        <a target="_blank" rel="noopener noreferrer" href={link.route} id={link.id} className="nav-link-v2" key={link.id}>
            {TranslationUtils.get(link.displayText)}
        </a>
    );
};

const renderDropdownLink = (link: NavbarLink) => {
    return (
        <a target="_blank" rel="noopener noreferrer" href={link.route} id={link.id} className="dropdown-item pl-0">
            <span className={'mb-auto'}>{TranslationUtils.get(link.displayText)}</span>
        </a>
    );
};

export const LeftNavBarMenu = () => {
    return (
        <div className="navbar-nav nav-font">
            <div className="ml-0">
                {renderLink({
                    id: 'navbar-property-management',
                    route: 'https://www.vacasa.com/property-management',
                    displayText: 'property_management',
                    notifications: 0,
                })}
            </div>
            <div className="ml-0">
                {renderLink({
                    id: 'navbar-real-estate',
                    route: 'https://www.vacasa.com/real-estate',
                    displayText: 'real_estate',
                    notifications: 0,
                })}
            </div>
            <div className="nav-item-v2 nav-item dropdown ml-0 nav-font" tabIndex={0} onKeyPress={onKeyPress}>
                <a
                    id="company-dropdown-link"
                    className="nav-link-v2 dropdown-toggle d-flex mr-0"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <span>{TranslationUtils.get('company')}</span>
                    <IconCaretDownNoRadius className="icon-caret-down-nav-v2" />
                </a>
                <div className="dropdown-menu dropdown-menu-left nav-font" aria-labelledby="company-dropdown-link">
                    {companyLinks.map((dropdownLink, index) => (
                        <React.Fragment key={index}>{renderDropdownLink(dropdownLink)}</React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};
